/** Categories we can post physical samples for (boards, stone, hardware finishes). */
const SAMPLE_CATEGORIES = new Set(["board-products", "stone-options", "hardware", "accessories"]);
export const isSampleable = (item) => SAMPLE_CATEGORIES.has(item?.category);
